module.exports = __webpack_public_path__ + "img/banner.cb5faaf5.png";